import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/** `tn` translates the employeeNotices namespace; `t` the rest. */
export default function useEmployeeNoticesT() {
  const { t } = useTranslation(['employeeNotices', 'forms', 'messages']);
  const tn = useCallback(
    (key, opts) => t(key, { ns: 'employeeNotices', ...opts }),
    [t]
  );
  return { t, tn };
}

export const errorText = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;
